var map = {
	"./ball-stroke-00.png": 658,
	"./ball-stroke-01.png": 659,
	"./ball-stroke-02.png": 660,
	"./ball-stroke-03.png": 661,
	"./ball-stroke-04.png": 662,
	"./ball-stroke-05.png": 663,
	"./ball-stroke-06.png": 664,
	"./ball-stroke-07.png": 665,
	"./ball-stroke-08.png": 666,
	"./ball-stroke-09.png": 667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 280;